import IconEdit from "../../assets/svg/icon-edit-compratment.svg";
import IconDelete from "../../assets/svg/icon-delete-show-account.svg";
import Property from "../../assets/images/property.svg";
import IconMenu from "../../assets/svg/icon-menu-account.svg";

import { useState } from "react";
import { useDispatch } from "react-redux";
import { apiDeleteProperty } from "api/property";
import { setConfirm } from "store/actions/appAction";
import { useNavigate } from "react-router-dom";
const PropertyCard = ({ property, getFullData ,index}: { getFullData: () => void,index:number, property: { id: number, fa_title: string, Product_Property_Items: Array<{ id: number, en_title: string, fa_title: string }> } }) => {
  const [active, setActive] = useState(false)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const deleteProperty = () => {
    //@ts-ignore
    dispatch(apiDeleteProperty({
      cb: (res: any) => {
        getFullData()
      }, id: property.id
    }))
  }
  return (
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 style-body-card">
      <div className="card-box">
        <div className={active ? "active-toggle-menu-account" : "not-active-toggle-menu-account"}>
          <div onClick={() => {

            navigate(`/productsproperty/${property.id}`)

          }}>
            <img src={IconEdit} alt="IconEdit" />
            ویرایش
          </div>
          <div onClick={() => {
            dispatch(setConfirm("حذف ویژگی", () => {
              deleteProperty()
            }, undefined, "آیا از حذف ویژگی مطمئن هستید؟"));
          }}>
            <img src={IconDelete} alt="Icondelete" />
            حذف ویژگی
          </div>
        </div>
        <img className="logo-original opacity-5" src={Property} alt="original-logo" />
        <div className="header-card">
          <div className="right-header-card">
            <div />
            <div />
            <div className="logo-card">{index}</div>
          </div>
          <div className="left-header-card">
            <img src={IconMenu} alt="IconMenu" onClick={() => {
              setActive(state => !state)
            }} />
          </div>
        </div>
        <div className="title-card-box">
          <div className="new-div-title-card-box">
            {/* <div className="icon-logo-title-card-box">
                {/* <img src={Property} alt="logoShareholder" /> 
              </div> */}
            <div>
              <div>
                {property.fa_title}
              </div>
              {/*<div className="text-small-card-box">{shareholder?.Roles[0]?.fa_title ?? ''}</div>*/}
            </div>
          </div>
          <div className="count-title-card-box">{ }</div>
        </div>
        <p className="text-number-card">
          {/* <img src={chartIconShareholder} alt="chartIconShareholder" /> */}
        </p>
        <div className="line-card" />
        <div className="footer-card">
          <span></span>
        </div>
      </div>
    </div>
  );
}

export default PropertyCard;